@if (isLoading) {
  <div class="cover-spin"></div>
}
@if (user) {
  <mat-card class="mt-5 d-block m-auto">
    <div
      class="h4 mb-3"
      [innerHTML]="'admin_portal.settings.heading.content' | translate"
    ></div>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title
            [innerHTML]="
              'admin_portal.settings.user_data_panel.heading.content'
                | translate
            "
          ></mat-panel-title>
          <mat-panel-description>
            {{
              'admin_portal.settings.user_data_panel.description.content'
                | translate
            }}
            <mat-icon class="non-responsive">account_circle</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-form-field appearance="outline">
          <mat-label
            [innerHTML]="
              'admin_portal.settings.user_data_panel.name_form_field.content'
                | translate
            "
          ></mat-label>
          <input matInput [value]="user.name" readonly />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label
            [innerHTML]="
              'admin_portal.settings.user_data_panel.username_form_field.content'
                | translate
            "
          ></mat-label>
          <input matInput [value]="user.username" readonly />
        </mat-form-field>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title
            [innerHTML]="
              'admin_portal.settings.multi_factor_panel.heading.content'
                | translate
            "
          ></mat-panel-title>
          <mat-panel-description>
            {{
              'admin_portal.settings.multi_factor_panel.description.content'
                | translate
            }}
            <mat-icon class="non-responsive">library_add</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-slide-toggle [(ngModel)]="user.is_multi_factor_user">{{
          'admin_portal.settings.multi_factor_panel.activate_second_factor.content'
            | translate
        }}</mat-slide-toggle>
        <div class="row mt-3">
          <div class="col-12 col-md-3">
            <!-- Country code form field -->
            <mat-form-field appearance="outline">
              <mat-label
                [innerHTML]="
                  'admin_portal.settings.multi_factor_panel.country_code_form_field.content'
                    | translate
                "
              ></mat-label>
              <mat-select
                [(ngModel)]="user.country_code"
                [disabled]="!user.is_multi_factor_user"
              >
                @for (country of countries; track country) {
                  <mat-option [value]="country.code">{{
                    country.name + ' (' + country.code + ')'
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-9">
            <!-- Phone number form field -->
            <mat-form-field appearance="outline">
              <mat-label
                [innerHTML]="
                  'admin_portal.settings.multi_factor_panel.phone_number_form_field.content'
                    | translate
                "
              ></mat-label>
              <input
                matInput
                maxlength="20"
                placeholder="123 45678910"
                [(ngModel)]="user.phone_number"
                [disabled]="!user.is_multi_factor_user"
              />
              <mat-icon matSuffix>phone</mat-icon>
              <mat-hint
                align="end"
                [innerText]="user.phone_number.length + ' / 20'"
              ></mat-hint>
            </mat-form-field>
          </div>
        </div>
        <!-- Submit button -->
        <button
          class="w-100 mt-2"
          (click)="updateUsersMultiFactor()"
          mat-raised-button
          color="primary"
          [disabled]="
            (user.is_multi_factor_user &&
              (!user.country_code ||
                !user.phone_number ||
                user.phone_number.length > 20)) ||
            isLoading
          "
          [innerHTML]="
            'admin_portal.settings.multi_factor_panel.submit_button.content'
              | translate
          "
        ></button>
        @if (updateMultiFactorSuccess) {
          <p
            class="success mt-3"
            [innerHTML]="
              'admin_portal.settings.multi_factor_panel.success_message.content'
                | translate
            "
          ></p>
        }
        @if (updateMultiFactorError) {
          <p
            class="error mt-3"
            [innerHTML]="
              'admin_portal.settings.multi_factor_panel.error_message.content'
                | translate
            "
          ></p>
        }
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title
            [innerHTML]="
              'admin_portal.settings.change_password_panel.heading.content'
                | translate
            "
          ></mat-panel-title>
          <mat-panel-description>
            {{
              'admin_portal.settings.change_password_panel.description.content'
                | translate
            }}
            <mat-icon class="non-responsive">lock</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <form
          #changePasswordNgForm="ngForm"
          [formGroup]="changePasswordForm"
          (ngSubmit)="onFormSubmit(changePasswordNgForm)"
        >
          <!-- Old password -->
          <mat-form-field appearance="outline">
            <mat-label
              [innerHTML]="
                'admin_portal.settings.change_password_panel.password_form_field.label.content'
                  | translate
              "
            ></mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              maxlength="100"
              formControlName="password"
            />
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
            >
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint
              align="end"
              [innerText]="changePasswordForm.value.password.length + ' / 100'"
            ></mat-hint>
            <mat-error>
              @if (
                !changePasswordForm.get('password').valid &&
                changePasswordForm.get('password').touched
              ) {
                <span
                  [innerHTML]="
                    'admin_portal.settings.change_password_panel.password_form_field.error_message.content'
                      | translate
                  "
                ></span>
              }
            </mat-error>
          </mat-form-field>
          <!-- New password -->
          <mat-form-field appearance="outline">
            <mat-label
              [innerHTML]="
                'admin_portal.settings.change_password_panel.new_password_form_field.label.content'
                  | translate
              "
            ></mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              maxlength="100"
              formControlName="new_password"
            />
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
            >
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint
              align="end"
              [innerText]="
                changePasswordForm.value.new_password.length + ' / 100'
              "
            ></mat-hint>
            <mat-error>
              @if (
                !changePasswordForm.get('new_password').valid &&
                changePasswordForm.get('new_password').touched
              ) {
                <span
                  [innerHTML]="
                    'admin_portal.settings.change_password_panel.new_password_form_field.error_message.content'
                      | translate
                  "
                ></span>
              }
            </mat-error>
          </mat-form-field>
          <!-- New password (repeated) -->
          <mat-form-field appearance="outline">
            <mat-label
              [innerHTML]="
                'admin_portal.settings.change_password_panel.repeat_new_password_form_field.label.content'
                  | translate
              "
            ></mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              maxlength="100"
              formControlName="new_password2"
            />
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
            >
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-hint
              align="end"
              [innerText]="
                changePasswordForm.value.new_password2.length + ' / 100'
              "
            ></mat-hint>
            <mat-error>
              @if (
                !changePasswordForm.get('new_password2').valid &&
                changePasswordForm.get('new_password2').touched
              ) {
                <span
                  [innerHTML]="
                    'admin_portal.settings.change_password_panel.repeat_new_password_form_field.error_message.content'
                      | translate
                  "
                ></span>
              }
            </mat-error>
          </mat-form-field>
          <!-- Submit button -->
          <button
            class="w-100 mt-2"
            type="submit"
            mat-raised-button
            color="primary"
            [disabled]="!changePasswordForm.valid || isLoading"
            [innerHTML]="
              'admin_portal.settings.change_password_panel.submit_button.content'
                | translate
            "
          ></button>
          @if (changePasswordSuccessMessage) {
            <p
              class="success mt-3"
              [innerHTML]="changePasswordSuccessMessage"
            ></p>
          }
          @if (changePasswordErrorMessage) {
            <p class="error mt-3" [innerHTML]="changePasswordErrorMessage"></p>
          }
        </form>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="mt-3">
      <button
        mat-flat-button
        [routerLink]="['admin']"
        routerLinkActive="router-link-active"
        [innerHTML]="'global.back_button.content' | translate"
      ></button>
    </div>
  </mat-card>
}
